import { useEffect, useState } from "react";
import { Package, FileText, Download, Eye, Lock } from "lucide-react";
import { getBundleInfo, getBundleFileUrl } from "../../utils/api";
import { formatBytes } from "../../utils/fileHelpers";

import "./BundleSharePage.css";

function downloadFile(url, filename) {
    fetch(url)
        .then((res) => res.blob())
        .then((blob) => {
            const a = document.createElement("a");
            const objectUrl = URL.createObjectURL(blob);
            a.href = objectUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(objectUrl);
        });
}

export default function BundleSharePage() {
    const token = window.location.pathname.split("/bundle/")[1];
    const [status, setStatus] = useState("loading");
    const [bundle, setBundle] = useState(null);

    useEffect(() => {
        if (!token) {
            setStatus("invalid");
            return;
        }
        getBundleInfo(token)
            .then((data) => {
                setBundle(data);
                setStatus("valid");
            })
            .catch(() => setStatus("invalid"));
    }, [token]);

    if (status === "loading")
        return (
            <div className="share-page">
                <div className="share-card">
                    <div className="share-page-icon">
                        <Package size={56} />
                    </div>
                    <h2>Checking link…</h2>
                    <p>Just a moment.</p>
                </div>
            </div>
        );

    if (status === "invalid")
        return (
            <div className="share-page">
                <div className="share-card">
                    <div
                        className="share-page-icon"
                        style={{ color: "var(--border-dk)" }}
                    >
                        <Lock size={56} />
                    </div>
                    <h2>Bundle not found</h2>
                    <p>
                        This link may have expired, been revoked, or never
                        existed.
                    </p>
                </div>
            </div>
        );

    return (
        <div className="bundle-page">
            <div className="bundle-page-card">
                <div className="bundle-page-header">
                    <div className="bundle-page-title">
                        <div className="bundle-page-icon">
                            <Package size={36} />
                        </div>
                        <div>
                            <h1>{bundle.name}</h1>
                            <p>
                                {bundle.files.length} file
                                {bundle.files.length !== 1 ? "s" : ""} shared
                                with you
                            </p>
                        </div>
                    </div>
                </div>

                <div className="bundle-page-list">
                    {bundle.files.map((file) => (
                        <div key={file._id} className="bundle-page-row">
                            <div className="bundle-page-row-icon">
                                <FileText size={22} />
                            </div>
                            <div className="bundle-page-row-info">
                                <div className="bundle-page-row-name">
                                    {file.name}
                                </div>
                                {file.size && (
                                    <div className="bundle-page-row-size">
                                        {formatBytes(file.size)}
                                    </div>
                                )}
                            </div>
                            <div className="bundle-page-row-actions">
                                <a
                                    href={getBundleFileUrl(token, file._id)}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="bundle-action-btn"
                                    title="View in browser"
                                >
                                    <Eye size={16} />
                                </a>
                                <button
                                    className="bundle-action-btn download"
                                    title="Download"
                                    onClick={() =>
                                        downloadFile(
                                            getBundleFileUrl(token, file._id),
                                            file.name,
                                        )
                                    }
                                >
                                    <Download size={16} />
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
